"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputFilterBehavior = void 0;
var bc_input_behavior_1 = require("../bc-input/bc-input-behavior");
var bc_input_filter_float_menu_1 = require("./bc-input-filter-float-menu");
var bc_float_menu_behavior_1 = require("../../organisms/bc-float-menu/bc-float-menu-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var common_constants_2 = require("../../../common/constants/common-constants");
var bc_float_menu_constants_1 = require("../../organisms/bc-float-menu/bc-float-menu-constants");
var bc_input_constants_1 = require("../bc-input/bc-input-constants");
var bc_input_constants_2 = require("../bc-input/bc-input-constants");
var bc_input_constants_3 = require("../bc-input/bc-input-constants");
var BcInputFilterBehavior = (function () {
    function BcInputFilterBehavior(id) {
        this.configInputFilter = { data: [] };
        this.attrDataAutoStateError = 'false';
        this.mySelf = document.getElementById(id).closest(".".concat(bc_input_constants_2.INPUT_FORM_FILE));
        this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ID, "".concat(id, "-").concat(bc_input_constants_2.INPUT_FORM_FILE));
        this.input = this.mySelf.querySelector(".".concat(bc_input_constants_1.INPUT_CLASS));
        this.idComponent = id;
        this._setInputFilter();
        this._inputListenerKeyboard();
    }
    BcInputFilterBehavior.prototype._setInputFilter = function () {
        this._initInputBehavior(this.idComponent);
        this._initFloatMenu();
        this._handleListennerKeyboardInput();
        this._handleListennerResize();
        this._handleListennerFocus();
        this._handleListennerEscape();
    };
    BcInputFilterBehavior.prototype._handleListennerFocus = function () {
        var _this = this;
        var firtFocus = true;
        this.input.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUS, function () {
            var _a;
            (_a = _this.input.classList) === null || _a === void 0 ? void 0 : _a.remove(bc_input_constants_3.INPUT_ERROR_CLASS);
            if (firtFocus) {
                _this._listenerClickOutsite();
                firtFocus = false;
            }
        });
    };
    BcInputFilterBehavior.prototype._listenerClickOutsite = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var outsiteClick = event.target.closest("#".concat(_this.idComponent, "-").concat(bc_input_constants_2.INPUT_FORM_FILE));
            if (!outsiteClick) {
                _this._handleListennerClickOutsite();
            }
        });
    };
    BcInputFilterBehavior.prototype._handleListennerClickOutsite = function () {
        this.bcFloatMenuBehavior.closeDropdown();
        this.arrowFloatMenu.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
        var itemActive = this.configInputFilter.data.find(function (data) { return data.isActive; });
        if (itemActive) {
            this.input.value = itemActive.text;
        }
        else {
            if (this.attrDataAutoStateError === 'true') {
                this.input.classList.add(bc_input_constants_3.INPUT_ERROR_CLASS);
            }
            this.input.value = '';
        }
    };
    BcInputFilterBehavior.prototype._handleListennerResize = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            _this._setWidthFloatMenuContent();
        });
    };
    BcInputFilterBehavior.prototype._handleListennerKeyboardInput = function () {
        var debounceFunction = this._debounce(this._handleTypeInput.bind(this), common_constants_2.COMMON_CONSTANTS_NUMBERS.N300);
        this.input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, debounceFunction);
    };
    BcInputFilterBehavior.prototype._handleTypeInput = function (event) {
        this._openDropdownFloatMenu();
        this.arrowFloatMenu.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_UP;
        if (this.inputValue) {
            this.inputValue(event.target.value, event);
        }
        if (!this.configInputFilter.preloader) {
            this.copyConfigInputFilter = JSON.parse(JSON.stringify(this.configInputFilter));
            var filter = this._filterInputItems(event.target.value);
            if (filter.length === 0) {
                this.bcFloatMenuBehavior.closeDropdown();
                this.arrowFloatMenu.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
            }
            else {
                var newConfig = {
                    data: filter
                };
                this._setListFloatMenu(newConfig);
                this._handleMoveList();
                this._handlePressEnterInItem();
            }
        }
    };
    BcInputFilterBehavior.prototype._filterInputItems = function (textToFilter) {
        return this.copyConfigInputFilter.data.filter(function (item) {
            return item.text.toLowerCase().trim().includes(textToFilter.toLowerCase().trim());
        });
    };
    BcInputFilterBehavior.prototype.resetSelection = function () {
        var _this = this;
        this.input.value = '';
        this._setItemsFalse();
        this._setAriaSelectedFalse();
        this._deleteClassSelectedFloatMenuContent();
        setTimeout(function () {
            var _a;
            (_a = _this.input.classList) === null || _a === void 0 ? void 0 : _a.remove(bc_input_constants_3.INPUT_ERROR_CLASS);
        });
    };
    BcInputFilterBehavior.prototype._openDropdownFloatMenu = function () {
        this._setWidthFloatMenuContent();
        this.bcFloatMenuBehavior.openDropdown();
        this.arrowFloatMenu.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_UP;
    };
    BcInputFilterBehavior.prototype._debounce = function (func, delay) {
        var timeoutId;
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(function () {
                func.apply(_this, args);
            }, delay);
        };
    };
    BcInputFilterBehavior.prototype._initFloatMenu = function () {
        this._configureFloatMenu();
        this.bcFloatMenuBehavior = new bc_float_menu_behavior_1.BcFloatMenuBehavior();
        this.bcFloatMenuBehavior.setId("".concat(this.idComponent, "-").concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CLASS));
        this.bcFloatMenuBehavior.setUp();
        this._handleToogleArrowFloatMenu();
    };
    BcInputFilterBehavior.prototype._handleToogleArrowFloatMenu = function () {
        var _this = this;
        this.arrowFloatMenu.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this._toogleDropdownFloatMenu();
        });
    };
    BcInputFilterBehavior.prototype._toogleDropdownFloatMenu = function () {
        var _a;
        if (((_a = this.configInputFilter.data) === null || _a === void 0 ? void 0 : _a.length) > 0 || this.configInputFilter.preloader > 0) {
            var contentFloatMenu = this.mySelf.querySelector("#".concat(this.idComponent, "-").concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS));
            if (contentFloatMenu.classList.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS)) {
                this.bcFloatMenuBehavior.closeDropdown();
                this.arrowFloatMenu.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
            }
            else {
                this._openDropdownFloatMenu();
                this.arrowFloatMenu.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_UP;
                this.input.focus();
            }
            this._setListFloatMenu(this.configInputFilter);
            this._handleMoveList();
            this._handlePressEnterInItem();
        }
    };
    BcInputFilterBehavior.prototype._configureFloatMenu = function () {
        this.bcInputFilterFloatMenu = new bc_input_filter_float_menu_1.BcInputFilterFloatMenu(this.idComponent);
        var floatMenu = this.bcInputFilterFloatMenu.createBaseFloatMenu();
        this._configArrowFloatMenu();
        this.arrowFloatMenu.after(floatMenu);
    };
    BcInputFilterBehavior.prototype._configArrowFloatMenu = function () {
        this.arrowFloatMenu = this.input.nextElementSibling;
        this.arrowFloatMenu.setAttribute(common_constants_1.BcCommonConstants.ID, "".concat(this.idComponent, "-arrow-float-menu"));
        this.arrowFloatMenu.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, '0');
        this.arrowFloatMenu.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_TOGGLE_CLASS);
        this.arrowFloatMenu.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
        this.arrowFloatMenu.setAttribute(common_constants_1.BcCommonConstants.ROLE, common_constants_1.BcCommonConstants.ROLE_BUTTON);
        this._handlePressEnterIntoArrow();
    };
    BcInputFilterBehavior.prototype._handlePressEnterIntoArrow = function () {
        var _this = this;
        this.arrowFloatMenu.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            var eventKeys = [common_constants_1.BcCommonConstants.KEY_EVENT_ENTER, ' '];
            if (eventKeys.includes(event.key)) {
                event.preventDefault();
                _this.arrowFloatMenu.click();
                var firstElement = _this.mySelf.querySelector(common_constants_1.BcCommonConstants.LI_TAG);
                while (firstElement && firstElement.getAttribute(common_constants_1.BcCommonConstants.TABINDEX) === '-1') {
                    firstElement = firstElement.nextElementSibling;
                }
                firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
            }
        });
    };
    BcInputFilterBehavior.prototype._initInputBehavior = function (id) {
        this.bcInputBehavior = new bc_input_behavior_1.BcInputBehavior();
        this.bcInputBehavior.setId("".concat(id));
        this.bcInputBehavior.setUp();
        this.attrDataAutoStateError = this.input.getAttribute('data-auto-state-error');
        this.input.setAttribute(common_constants_1.BcCommonConstants.AUTOCOMPLETE, 'off');
        this.input.setAttribute(common_constants_1.BcCommonConstants.ROLE, common_constants_1.BcCommonConstants.ROLE_COMBOBOX);
    };
    BcInputFilterBehavior.prototype.setValue = function (configInputFilter) {
        this.configInputFilter = configInputFilter;
        this._setListFloatMenu(this.configInputFilter);
        this._setValueInInput();
        this._handleMoveList();
        this._handlePressEnterInItem();
    };
    BcInputFilterBehavior.prototype._setListFloatMenu = function (configInputFilter) {
        this._deleteListFloatMenu();
        var listFloatMenu = this.bcInputFilterFloatMenu.createListFloatMenu(configInputFilter);
        this._handleEventClick();
        var floatMenuContent = this.mySelf.querySelector("#".concat(this.idComponent, "-").concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS));
        floatMenuContent.appendChild(listFloatMenu);
    };
    BcInputFilterBehavior.prototype._handleEventClick = function () {
        var _this = this;
        this.bcInputFilterFloatMenu.onEventClick = function (item, event, liElement) {
            var value = item.value === undefined ? item.text : item.value;
            _this._setItemsFalse();
            _this._setIsActiveValue(item);
            _this._setAriaSelectedFalse();
            liElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, 'true');
            if (_this.selectedValue) {
                _this.selectedValue(value, event);
            }
            _this.input.value = item.text;
            _this._deleteClassSelectedFloatMenuContent();
            liElement.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS);
            _this.bcFloatMenuBehavior.closeDropdown();
            _this.arrowFloatMenu.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
        };
    };
    BcInputFilterBehavior.prototype._setAriaSelectedFalse = function () {
        this.mySelf.querySelector(common_constants_1.BcCommonConstants.UL_TAG).childNodes.forEach(function (li) {
            li.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, 'false');
        });
    };
    BcInputFilterBehavior.prototype._setIsActiveValue = function (item) {
        var itemSelected = this.configInputFilter.data.find(function (data) { return data.text === item.text; });
        itemSelected.isActive = true;
    };
    BcInputFilterBehavior.prototype._setValueInInput = function () {
        var _this = this;
        var _a;
        (_a = this.configInputFilter.data) === null || _a === void 0 ? void 0 : _a.forEach(function (data) {
            if (data.isActive) {
                _this.input.value = data.text;
            }
        });
    };
    BcInputFilterBehavior.prototype._setItemsFalse = function () {
        this.configInputFilter.data.forEach(function (data) {
            data.isActive = false;
        });
    };
    BcInputFilterBehavior.prototype._deleteClassSelectedFloatMenuContent = function () {
        this.mySelf.querySelector(common_constants_1.BcCommonConstants.UL_TAG).childNodes.forEach(function (li) {
            li.classList.remove(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS);
        });
    };
    BcInputFilterBehavior.prototype._setWidthFloatMenuContent = function () {
        var floatMenuContent = this.mySelf.querySelector("#".concat(this.idComponent, "-").concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS));
        var width = this.mySelf.querySelector(".".concat(bc_input_constants_1.INPUT_CLASS)).clientWidth;
        floatMenuContent.style.width = "".concat(width, "px");
    };
    BcInputFilterBehavior.prototype._deleteListFloatMenu = function () {
        var listFloatMenu = this.mySelf.querySelector("#".concat(this.idComponent, "-").concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS, " > ").concat(common_constants_1.BcCommonConstants.UL_TAG));
        if (!!listFloatMenu) {
            listFloatMenu.remove();
        }
    };
    BcInputFilterBehavior.prototype._handleListennerEscape = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this._handleListennerClickOutsite();
                _this.input.blur();
            }
        });
    };
    BcInputFilterBehavior.prototype._inputListenerKeyboard = function () {
        var _this = this;
        this.input.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            _this._moveArrowDownToInput(event);
            _this._moveArrowUpToInput(event);
        });
    };
    BcInputFilterBehavior.prototype._moveArrowDownToInput = function (event) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            event.preventDefault();
            this._openDropdownFloatMenu();
            var firstElement = this.mySelf.querySelector(common_constants_1.BcCommonConstants.LI_TAG);
            while (firstElement && firstElement.getAttribute(common_constants_1.BcCommonConstants.TABINDEX) === '-1') {
                firstElement = firstElement.nextElementSibling;
            }
            firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
        }
    };
    BcInputFilterBehavior.prototype._moveArrowUpToInput = function (event) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
            event.preventDefault();
            this._openDropdownFloatMenu();
            var liElements = this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG);
            var lastElement = liElements[liElements.length - 1];
            while (lastElement && lastElement.getAttribute(common_constants_1.BcCommonConstants.TABINDEX) === '-1') {
                lastElement = lastElement.previousElementSibling;
            }
            lastElement === null || lastElement === void 0 ? void 0 : lastElement.focus();
        }
    };
    BcInputFilterBehavior.prototype._handleMoveList = function () {
        var _this = this;
        var list = this.mySelf.querySelector(common_constants_1.BcCommonConstants.UL_TAG);
        list.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            _this.handleArrowNavigation(event);
        });
    };
    BcInputFilterBehavior.prototype.handleArrowNavigation = function (event) {
        this._moveArrowDownToList(event);
        this._moveArrowUpToList(event);
    };
    BcInputFilterBehavior.prototype._moveArrowDownToList = function (event) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            var nextElement = event.target.nextElementSibling;
            while (nextElement && nextElement.getAttribute(common_constants_1.BcCommonConstants.TABINDEX) === '-1') {
                nextElement = nextElement.nextElementSibling;
            }
            if (nextElement) {
                nextElement.focus();
            }
        }
    };
    BcInputFilterBehavior.prototype._moveArrowUpToList = function (event) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
            var prevElement = event.target.previousElementSibling;
            while (prevElement && prevElement.getAttribute(common_constants_1.BcCommonConstants.TABINDEX) === '-1') {
                prevElement = prevElement.previousElementSibling;
            }
            if (prevElement) {
                prevElement.focus();
            }
        }
    };
    BcInputFilterBehavior.prototype._handlePressEnterInItem = function () {
        var list = this.mySelf.querySelector(common_constants_1.BcCommonConstants.UL_TAG);
        list.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            var eventKeys = [common_constants_1.BcCommonConstants.KEY_EVENT_ENTER, ' '];
            if (eventKeys.includes(event.key)) {
                event.target.click();
            }
        });
    };
    return BcInputFilterBehavior;
}());
exports.BcInputFilterBehavior = BcInputFilterBehavior;
